import { type FC } from 'react';

import { Button, DesignToken, Heading, Text } from '@livechat/design-system-react-components';

import { TEXT_PROMO_URL, trackTextPromoClick } from 'helpers/text-promo';

import * as styles from './styles';

export const TextPromoCard: FC = () => {
  return (
    <section className={styles.promoCard} aria-label="Discover Text">
      <Heading size="xs" className={styles.promoTitle} customColor={`var(${DesignToken.ContentBasicPrimary})`}>
        Upgrade to Text at the same price
      </Heading>
      <Text size="md" noMargin customColor={`var(${DesignToken.ContentBasicSecondary})`}>
        Chats and tickets in one inbox, plus an AI Agent that supports and sells for you. Your setup comes with you.
      </Text>
      <Button
        className={styles.promoCta}
        kind="high-contrast"
        href={TEXT_PROMO_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackTextPromoClick('product_switcher')}
      >
        Discover Text
      </Button>
    </section>
  );
};
